module.exports = __webpack_public_path__ + "h5/img/userBgs.a1f00be7.jpg";